import CardHeader from "components/CardHeader";
import { Tenant } from "models/Tenant";
import React from "react";
import { Card, CardBody } from "reactstrap";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

const TenantOverviewCard: React.FC<{ tenant: Tenant }> = ({ tenant }) => {
    const { t } = useOfficeTranslation();
    return <Card>
        <CardBody>
            <CardHeader title={t("tenants.tenantOverviewCard.title")} icon="mdi-domain" />
            <div className="d-flex justify-content-between gap-3 border-bottom py-3">
                <span className="text-muted">{t("common.name")}</span>
                <span className="text-end">{tenant.name}</span>
            </div>
            <div className="d-flex justify-content-between gap-3 border-bottom py-3">
                <span className="text-muted">{t("tenants.tenantOverviewCard.pushSubscriptions")}</span>
                <span>{tenant.webpush?.subscriptions ?? 0}</span>
            </div>
            <div className="d-flex justify-content-between gap-3 pt-3">
                <span className="text-muted">{t("tenants.tenantOverviewCard.tenantId")}</span>
                <span className="text-end text-break">{tenant.id}</span>
            </div>
        </CardBody>
    </Card>;
};

export default TenantOverviewCard;
